var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infinite-scroll-container"},[_vm._v("sap")])
}
var staticRenderFns = []

export { render, staticRenderFns }